import React from "react";
import produce from "immer";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { IconButton, TextField } from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

import { rupeeDisplay } from "../../../helpers/rupee";
import { TeethSelector } from "./TeethSelector";
import {
  DentalService,
  IntraOralValue,
  TreatmentDoneItem
} from "../../../interfaces/AssessmentInterfaces";

interface PropType {
  intraOral: Record<"permanent" | "primary", Record<string, IntraOralValue>>;
  services: Array<DentalService>;
  item: DentalService;
  index: number;
  treatmentDone?: TreatmentDoneItem[];
  handleRemoveService: (i: Array<DentalService>, v: TreatmentDoneItem[]) => void;
  handleUpdateService: (v: DentalService) => void;
}

// eslint-disable-next-line import/prefer-default-export
export function DentalServicesRow({
  item,
  services,
  handleRemoveService,
  handleUpdateService,
  treatmentDone = [],
  index,
  intraOral
}: PropType): React.ReactNode {
  const [note, setNote] = React.useState<string>(item?.note || "");

  const intraOralPrimaryKeys = Object.keys(intraOral.primary ?? {});
  const intraOralPermanentKeys = Object.keys(intraOral.permanent ?? {});
  const teethOptions = [...intraOralPrimaryKeys, ...intraOralPermanentKeys];

  return (
    <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
      <TableCell>{index + 1}.</TableCell>
      <TableCell>{item.name}</TableCell>
      <TableCell>
        <TeethSelector
          options={teethOptions}
          item={item}
          onChange={(selectedTeeth) => {
            const uniqueTeeth = Array.from(new Set(selectedTeeth));

            handleUpdateService({
              ...item,
              teeth: uniqueTeeth
            });
          }}
        />
      </TableCell>
      <TableCell>
        <TextField
          value={note}
          placeholder="Note"
          onChange={(event) => setNote(event.target.value)}
          onBlur={() => handleUpdateService({ ...item, note })}
          variant="outlined"
          sx={{ width: "100%" }}
        />
      </TableCell>
      <TableCell sx={{ textAlign: "right" }}>
        {rupeeDisplay(Number(item.grossTotalPrice))}
      </TableCell>
      <TableCell sx={{ textAlign: "right" }}>
        <IconButton
          color="error"
          onClick={() => {
            const mutatedServices = produce(services, (draft) => {
              draft.splice(index, 1);
            });
            let updatedTreatmentDone = [] as TreatmentDoneItem[];
            if (treatmentDone.length) {
              updatedTreatmentDone = produce(treatmentDone, (draft) => {
                draft.splice(index, 1);
              });
            }
            handleRemoveService(mutatedServices, updatedTreatmentDone);
          }}
          size="small"
        >
          <DeleteForeverIcon />
        </IconButton>
      </TableCell>
    </TableRow>
  );
}
